import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

// Components
import ProfileSelection from './components/ProfileSelection';
import Header from './components/Header';
import Home from './pages/Home';
import Browse from './pages/Browse';
import Search from './pages/Search';
import MyList from './pages/MyList';
import Debug from './pages/Debug';
import Settings from './pages/Settings';
import VideoPlayer from './components/VideoPlayer';
import ContentDetails from './components/ContentDetails';

const AppContainer = styled.div`
  min-height: 100vh;
  background-color: #141414;
  color: white;
`;

const MainContent = styled.main`
  padding-top: ${props => props.$hasHeader ? '70px' : '0'};
  min-height: 100vh;
`;

function App() {
  const { isAuthenticated, currentProfile } = useSelector(state => state.user);
  const { currentlyPlaying } = useSelector(state => state.content);

  if (currentlyPlaying) {
    return <VideoPlayer />;
  }

  if (!isAuthenticated || !currentProfile) {
    return (
      <AppContainer>
        <ProfileSelection />
      </AppContainer>
    );
  }

  return (
    <AppContainer>
      <Header />
      <MainContent $hasHeader={true}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/browse" element={<Browse />} />
          <Route path="/search" element={<Search />} />
          <Route path="/my-list" element={<MyList />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/debug" element={<Debug />} />
          <Route path="/title/:id" element={<ContentDetails />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </MainContent>
    </AppContainer>
  );
}

export default App;